import { message } from 'antd';
import { filteringInitialState, setFilterData } from 'common/commonRedux/feature/filteringSlice';
import { apiCalling } from 'common/commonRedux/getRTKApi/baseApi';
import { jwtDecode } from "jwt-decode";
import { empListInitialState, setEpmListData } from '../feature/empListSlice';
import { rustApiCalling } from '../getRTKApi/rustApi';
import { clearLocalStorageAction } from '../reduxForLocalStorage/actions';
import * as requestFromServer from './api';
import { authSlice } from './slice';
const { actions: slice } = authSlice;


type JwtPayload = {
  role: string;
  accountid: string;
  userid: string;
  emailaddress: string;
  name: string;
  userType: string;
  sub: string;
  jti: string;
  iat: string;
  exp: number;
  iss: string;
  aud: string;
  refreshToken: string;
  trackingPeriodInSecond: number;
  maxIdleTimeInSecond: number;
  orgName: string;
  roleId: string;

};

const trackforceToken = (token: string): JwtPayload | null => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    console.log(decoded)
    return decoded;
  } catch (error) {
    console.error("Failed to decode JWT:", error);
    return null;
  }
};



// export const setLoginAction = (obj: any) => (dispatch: any) => {
//   const { email, password, navigate } = obj;
//   const key = 'login';
//   message.loading({ content: 'Loading...', key, duration: 10 });

//   return requestFromServer
//     .loginApiCall(email, password)
//     .then((res) => {
//       // console.log("res?.data?.token = ", res?.data);
//       const decodedToken = trackforceToken(res?.data?.token);

//       if (decodedToken) {
//         // console.log("decodedToken = ", decodedToken);
//         navigate('/');
//         dispatch(
//           slice.setLogin({
//             ...res.data,
//             tokenData: { ...decodedToken },
//           })
//         );

//         message.success({ content: 'Login successful', key, duration: 2 });
//       } else {
//         message.error({
//           content: 'Invalid token received, please try again!',
//           key,
//           duration: 2,
//         });
//       }
//     })
//     .catch((error) => {
//       message.error({
//         content:
//           error?.response?.data?.message || 'Login failed, please try again!',
//         key,
//         duration: 2,
//       });
//     });
// };

const LOGIN_MESSAGE_KEY = "login";

// Post-authentication handling shared by password login and one-time (OTP)
// login — both endpoints return the same AuthResponseDTO shape.
const handleAuthResponse = (res: any, navigate: any, dispatch: any) => {
  const key = LOGIN_MESSAGE_KEY;
  const isSuspended = res?.data?.isSuspended;
  const token = res?.data?.token;
  const billId = res?.data?.billId;
  const hasDueBill = res?.data?.hasDueBill;
  const serverMessage = res?.data?.message;
  if(billId && hasDueBill){
    message.warning({
      content:
        serverMessage ||
        "There's an outstanding balance on your account. Please settle it to continue.",
      key,
      duration: 5,
    });
    return res;
  }
  // 1) isSuspended = true → token null → just return response
  if (isSuspended) {
    message.error({
      content:
        serverMessage || "Your account is suspended. Please contact support.",
      key,
      duration: 5, // overrides loading
    });
    return res;
  }

  // 2) isSuspended = false but token missing → ERROR
  if (!token && !res?.data?.billId && !isSuspended) {
    throw new Error("Login failed!");
  }
  // 3) isSuspended = false & token exists → normal login
  const decodedToken = trackforceToken(token);

  navigate("/");
  dispatch(
    slice.setLogin({
      ...res.data,
      tokenData: { ...decodedToken },
    })
  );

  message.success({ content: "Login successful", key, duration: 2 });
  return res;
};

const handleAuthError = (error: any) => {
  message.error({
    content:
      error?.response?.data?.message ||
      error?.response?.data?.Message ||
      error?.message ||
      "Login failed!",
    key: LOGIN_MESSAGE_KEY,
    duration: 5,
  });

  throw error;
};

export const setLoginAction = (obj: any) => (dispatch: any) => {
  const { email, password, navigate } = obj;
  message.loading({ content: "Loading...", key: LOGIN_MESSAGE_KEY, duration: 10 });
  return requestFromServer
    .loginApiCall(email, password)
    .then((res) => handleAuthResponse(res, navigate, dispatch))
    .catch(handleAuthError);
};

// One-time login via emailed OTP. The web app is admin-only, so an employee
// account is rejected before anything is written to the auth state.
export const setOtpLoginAction = (obj: any) => (dispatch: any) => {
  const { email, otp, navigate } = obj;
  message.loading({ content: "Loading...", key: LOGIN_MESSAGE_KEY, duration: 10 });
  return requestFromServer
    .verifyLoginOtpApiCall(email, otp)
    .then((res) => {
      if (res?.data?.accountType && res.data.accountType !== "Admin") {
        throw new Error(
          "This login method is only for admin accounts. Please use the TrackForce desktop app."
        );
      }
      return handleAuthResponse(res, navigate, dispatch);
    })
    .catch(handleAuthError);
};


export const setLogoutAction = () => (dispatch: any) => {
  dispatch(setFilterData(filteringInitialState))
  dispatch(setEpmListData(empListInitialState))
  // dispatch(setDarkMode(themeInitialState?.isDark))
  dispatch(apiCalling.util.resetApiState())
  dispatch(rustApiCalling.util.resetApiState())
  dispatch(slice.setLogout());
  dispatch(clearLocalStorageAction());
  sessionStorage.removeItem("installPromptShown")
};

export const featurePermissionCheckAction = (obj: any) => (dispatch: any) => {
  dispatch(slice.setFeaturePermissionCheck(obj));
};


export const setShowEmailAciton = (email: string) => (dispatch: any) => {
  dispatch(slice.setShowEmail(email));
};

export const setOtpVerifiedEmailAction = (email: string) => (dispatch: any) => {
  dispatch(slice.setOtpVerifiedEmail(email));
};
export const setCommonRefreshAction = (payload: object) => (dispatch: any) => {
  dispatch(slice.setCommonRefreshObj(payload));
};
export const setAllEmpListRefetchAction = (payload: object) => (dispatch: any) => {
  dispatch(slice.setAllEmpListRefetch(payload));
};

export const setImpersonationAction = (token: string, account?: any) => (dispatch: any) => {
  const tokenData = trackforceToken(token);
  dispatch(slice.setImpersonation({ token, tokenData, account }));
  // Drop cached API data so subsequent requests refetch with the new identity.
  dispatch(apiCalling.util.resetApiState());
  dispatch(rustApiCalling.util.resetApiState());
};

export const clearImpersonationAction = () => (dispatch: any) => {
  dispatch(slice.clearImpersonation());
  dispatch(apiCalling.util.resetApiState());
  dispatch(rustApiCalling.util.resetApiState());
};

export const setSignupContextAction = (payload: {
  isTrial?: boolean;
  billingPeriod?: 'Monthly' | 'Yearly';
  planId?: number;
  planType?: string;
  planName?: string;
  effectivePricePerUser?: number;
  currencySymbol?: string;
  trialDays?: number;
  trialEmployeeSlots?: number;
  trialEmployeeSlotsLabel?: string;
}) => (dispatch: any) => {
  dispatch(slice.setSignupContext(payload));
};
